// ============================================================
// 期間カレンダー（v1.12.3・社長指示 2026-08-05）
//
// 航空会社の予約カレンダーと同じ見え方にする：
//   開始日と終了日は塗りつぶしの丸、その間は帯でつなぐ。
//   1回目のタップ＝開始日、2回目＝終了日。両方決まった状態でタップすると引き直し。
//
// ネイティブの <input type="date"> では期間を帯で見せられないため自作にした。
// 日付の計算は tripLogic の純関数（buildMonthGrid / rangeCellKind / pickRange）に
// 寄せてあり、このファイルは表示と操作だけを持つ。
// ============================================================

import React, { useState } from 'react';
import {
  buildMonthGrid,
  rangeCellKind,
  pickRange,
  parseDateStr,
  addMonths,
  localDateStr,
} from '../utils/tripLogic';

const WEEK_LABELS = ['日', '月', '火', '水', '木', '金', '土'];

export default function DateRangeCalendar({ startDate, endDate, onChange }) {
  // 開いたときに見せる月：開始日の月 → 無ければ今月
  const base = parseDateStr(startDate) || parseDateStr(localDateStr());
  const [ym, setYm] = useState({ y: base.y, m: base.m });

  const cells = buildMonthGrid(ym.y, ym.m);
  const today = localDateStr();

  const handleTap = (dateStr) => {
    onChange(pickRange(startDate || null, endDate || null, dateStr));
  };

  const hint = !startDate
    ? '開始日をタップしてください'
    : !endDate
      ? '終了日をタップしてください（同じ日でも可）'
      : 'もう一度タップすると開始日から選び直せます';

  return (
    <div className="drc">
      <div className="drc-head">
        <button
          type="button"
          className="drc-nav app-tappable"
          onClick={() => setYm(addMonths(ym.y, ym.m, -1))}
          aria-label="前の月"
        >
          ‹
        </button>
        <span className="drc-title">
          {ym.y}年 {ym.m}月
        </span>
        <button
          type="button"
          className="drc-nav app-tappable"
          onClick={() => setYm(addMonths(ym.y, ym.m, 1))}
          aria-label="次の月"
        >
          ›
        </button>
      </div>

      <div className="drc-week">
        {WEEK_LABELS.map((w, i) => (
          <span key={w} className={`drc-week-cell${i === 0 ? ' is-sun' : ''}${i === 6 ? ' is-sat' : ''}`}>
            {w}
          </span>
        ))}
      </div>

      <div className="drc-grid">
        {cells.map((c) => {
          const kind = rangeCellKind(c.date, startDate || null, endDate || null);
          const classes = [
            'drc-cell',
            c.inMonth ? '' : 'is-out',
            c.date === today ? 'is-today' : '',
            kind ? `is-${kind}` : '',
          ]
            .filter(Boolean)
            .join(' ');
          return (
            <button
              key={c.date}
              type="button"
              className={classes}
              onClick={() => handleTap(c.date)}
              aria-label={c.date}
              aria-pressed={kind === 'start' || kind === 'end' || kind === 'single'}
            >
              <span className="drc-cell-num">{c.day}</span>
            </button>
          );
        })}
      </div>

      <p className="drc-hint">{hint}</p>
    </div>
  );
}
